import React, { useEffect, useState, useRef, forwardRef } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { convertGenderNam } from "../../helpers/user";
import consts from "../../consts";
import { formateDateSlash } from "../../common/super";
import ReactToPrint from "react-to-print";
import "./index.css";

const EntranceCard = forwardRef(({ data, show, close }, ref) => {
  const componentRef = useRef();
  const [splitEntranceCode, setSplitEntranceCode] = useState([]);
  const [birthDay, setBirthDay] = useState([]);

  useEffect(() => {
    let newData = data?.student?.entranceCode?.split("");
    setSplitEntranceCode(newData);

    if (data?.student?.birthday) {
      let birthDayData = formateDateSlash(data?.student?.birthday)?.split("/");
      setBirthDay(birthDayData);
    }
  }, [data]);

  // The printable content
  const PrintableContent = () => (
    <div>
      <Row className="p-0 m-0">
        <div
          className="img-print-container"
          style={{ position: "relative", bottom: -22 }}
        >
          <div className="img-print-box">
            <img
              src={consts.S3_IMAGE + data?.student?.image}
              className="img-print"
            />
          </div>
        </div>
        <Col>
          <Row>
            <Col>
              <div className="text-center ml-4" style={{ fontWeight: "bold" }}>
                <p className="p-0 m-0">ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ</p>
                <p className="p-0 m-0">
                  ສັນຕິພາບ ເອກະລາດ ປະຊາທິປະໄຕ ເອກະພາບ ວັດທະນາຖາວອນ
                </p>
              </div>
              <Row className="mt-4">
                <Col style={{ marginLeft: 5 }}>
                  <p style={{ fontWeight: "normal" }} className="p-0 m-0">
                    ກະຊວງສຶກສາທິການ ແລະ ກິລາ
                  </p>
                  <p style={{ fontWeight: "normal" }} className="p-0 m-0">
                    ຄະນະກຳມະການສອບເສັງ
                  </p>
                </Col>
                <Col></Col>
              </Row>
            </Col>
            <div
              className="d-flex flex-column justify-content-around"
              style={{ width: "auto", marginTop: 35 }}
            >
              <div className="text-center">
                ຫ້ອງສອບເສັງ:{" "}
                <span className="text-primary font-number">
                  {data?.student?.classroom?.name}
                </span>
              </div>
              <div className="row">
                ເລກທີ:
                <div
                  className="ml-2 text-center"
                  style={{ width: "fit-content" }}
                >
                  <div className="row">
                    {splitEntranceCode?.length > 0 ? (
                      splitEntranceCode?.map((item, index) => (
                        <div
                          className="code-box text-primary font-number"
                          key={index}
                        >
                          {item}
                        </div>
                      ))
                    ) : (
                      <>
                        <div className="code-box"></div>
                        <div className="code-box"></div>
                        <div className="code-box"></div>
                        <div className="code-box"></div>
                        <div className="code-box"></div>
                      </>
                    )}
                  </div>
                  <span style={{ fontSize: 10 }}>(ສຳລັບພະນັກງານລົງທະບຽນ)</span>
                </div>
              </div>
            </div>
          </Row>
          <Row>
            <div style={{ marginLeft: 5, marginTop: 15 }}>
              <p className="p-0 m-0" style={{ fontWeight: "bold" }}>
                ຫົວໜ້າຄະນະກຳມະການສອບເສັງຄັດເລືອກເອົານັກຮຽນເຂົ້າຮຽນຕໍ່
                ທີ່ມະຫາວິທະຍາໄລ ຈຳປາສັກ
              </p>
            </div>
          </Row>
        </Col>
      </Row>
      <div className="px-1 mt-3" style={{ lineHeight: 2 }}>
        <div className="text-justify">
          ອະນຸຍາດໃຫ້ ທ້າວ/ນາງ:
          <span
            className="input-data text-primary"
            style={{ padding: "0 40px" }}
          >
            {convertGenderNam(data?.student?.gender)}
            <span style={{ marginLeft: 5 }}>{data?.student?.firstNameL}</span>
          </span>
          , ນາມສະກຸນ:
          <span
            className="input-data text-primary"
            style={{ padding: "0 40px" }}
          >
            {data?.student?.lastNameL}
          </span>
          , ວັນ,ເດືອນ,ປີເກີດ:
          <span
            className="input-data text-primary font-number"
            style={{ padding: "0 10px", bottom: 6 }}
          >
            {birthDay?.[2]}
          </span>
          /
          <span
            className="input-data text-primary font-number"
            style={{ padding: "0 10px", bottom: 6 }}
          >
            {birthDay?.[1]}
          </span>
          /
          <span
            className="input-data text-primary font-number"
            style={{ padding: "0 10px", bottom: 6 }}
          >
            {birthDay?.[0]}
          </span>
          , ບ້ານເກີດ:
          <span
            className="input-data text-primary"
            style={{ padding: "0 5px" }}
          >
            {data?.student?.birthAddress?.village}
          </span>
          , ເມືອງ:
          <span
            className="input-data text-primary"
            style={{ padding: "0 5px" }}
          >
            {data?.student?.birthAddress?.district}
          </span>
          , ແຂວງ:
          <span
            className="input-data text-primary"
            style={{ padding: "0 5px" }}
          >
            {data?.student?.birthAddress?.province}
          </span>
        </div>
        <div className="d-flex gap-4">
          <span>
            <span style={{ fontWeight: "bold" }}>
              ມີຈຸດປະສົງສະໜັກເຂົ້າສອບເສັງສາຍ
            </span>{" "}
            (ໝາຍ ✔ ໃສ່ບ໋ອກ):
          </span>
          <div className="d-flex">
            <div className="code-box text-primary mt-2 ml-5">
              {data?.group === "A" ? "✔" : ""}
            </div>
            <span className="ml-2">
              ສາຍ<span className="font-number"> A</span>
            </span>
          </div>
          <div className="d-flex">
            <div className="code-box text-primary mt-2 ml-5">
              {data?.group === "B" ? "✔" : ""}
            </div>
            <span className="ml-2">
              ສາຍ<span className="font-number"> B</span>
            </span>
          </div>
        </div>
        <Row className="my-1">
          <Col md={4}>
            <span>ທີ່ສູນສອບເສັງ (ສຳລັບພະນັກງານ):</span>
          </Col>
          <Col className="p-0 m-0">
            <Row className="p-0 m-0">
              <Col className="p-0 m-0">
                <div className="d-flex">
                  <div className="code-box text-primary mt-2">{"✔"}</div>
                  <span className="ml-2">ມະຫາວິທະຍາໄລ ຈຳປາສັກ</span>
                </div>
              </Col>
              <Col md={3}></Col>
            </Row>
          </Col>
        </Row>
        <Row className="p-0 m-0">
          <Col className="p-0 m-0">
            <span>
              ສອບເສັງວັນທີ:
              <span style={{ fontWeight: "bold" }}>
                <span className="font-number"> 26</span> ສິງຫາ{" "}
                <span className="font-number">2026</span>
              </span>
            </span>
          </Col>
          <Col className="text-right p-0 m-0 mt-4 entrance-license-container">
            {/* <span>
              ທີ່:..................................., ວັນທີ:......../......../
              <span className="font-number">{new Date().getFullYear()}</span>
            </span> */}
            <div
              className="entrance-img-license-container"
              style={{ marginTop: 50 }}
            >
              <img
                className="entrance-img-license"
                style={{ width: 300 }}
                src="/assets/entrance-license.png"
                alt=""
              />
            </div>
          </Col>
        </Row>
        <div style={{ lineHeight: 0.5, marginBottom: 50 }}>
          <span>ໝາຍເຫດ:</span>
          <p className="ml-4 mt-3">
            - ຫ້າມນຳໃຊ້ເຄື່ອງມືສື່ສານທຸກປະເພດເປັນເດັດຂາດ
          </p>
          <p className="ml-4">- ນຳໃຊ້ສໍດຳເທົ່ານັ້ນໃນການສອບເສັງ</p>
          <p className="ml-4">
            - ອາຄານສອບເສັງ...................................
          </p>
        </div>
        {/* <div style={{ borderBottom: "2px dotted black" }} /> */}
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div className="">
        <div className="text-center mt-3">
          <strong>ຕາຕາລາງສອບເສັງ</strong>
        </div>
        <div>
          {" "}
          <strong>ວັນທີ 26 ສິງຫາ 2026</strong>{" "}
        </div>
        <div
          className="table-responsive"
          style={{
            fontSize: "10pt",
          }}
        >
          <div className="mt-2">
            {" "}
            <strong>ສາຍ A</strong>{" "}
          </div>
          <table className="table table-bordered">
            <thead
              className="thead-dark text-center"
              style={{
                whiteSpace: "nowrap",
              }}
            >
              <tr>
                <th
                  style={{
                    width: "70px",
                  }}
                >
                  ລໍາດັບ
                </th>
                <th
                  style={{
                    width: "180px",
                  }}
                >
                  ເວລາ
                </th>
                <th>ວິຊາສອບເສັງ ຈໍານວນຫົວຂໍ້: 40 ຂໍ້</th>
              </tr>
            </thead>
            <tbody className="text-center">
              <tr>
                <td>ຕອນເຊົ້າ</td>
                <td>09:00 - 11:00 (120 ນາທີ)</td>
                <td>ຄະນິດສາດ (A) + ຟີຊິກສາດ</td>
              </tr>
              <tr>
                <td>ຕອນບ່າຍ</td>
                <td>14:00 - 15:30 (90 ນາທີ)</td>
                <td>ພາສາລາວ - ວັນນະຄະດີ + ຊີວະສາດ + ເຄມີສາດ + ພາສາອັງກິດ</td>
              </tr>
            </tbody>
          </table>

          <div className="mt-5">
            {" "}
            <strong>ສາຍ B</strong>{" "}
          </div>
          <table className="table table-bordered ">
            <thead
              className="thead-dark text-center"
              style={{
                whiteSpace: "nowrap",
              }}
            >
              <tr>
                <th
                  style={{
                    width: "70px",
                  }}
                >
                  ລໍາດັບ
                </th>
                <th
                  style={{
                    width: "180px",
                  }}
                >
                  ເວລາ
                </th>
                <th>ວິຊາສອບເສັງ ຈໍານວນຫົວຂໍ້: 40 ຂໍ້</th>
              </tr>
            </thead>
            <tbody className="text-center">
              <tr>
                <td>ຕອນເຊົ້າ</td>
                <td>09:00 - 11:00 (120 ນາທີ)</td>
                <td>ຄະນິດສາດ (B) + ພາສາລາວ - ວັນນະຄະດີ</td>
              </tr>
              <tr>
                <td>ຕອນບ່າຍ</td>
                <td>14:00 - 15:30 (90 ນາທີ)</td>
                <td>ພູມສາດ + ປະຫວັດສາດ + ພາສາອັງກິດ</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  // If being used for modal display
  if (show) {
    return (
      <Modal show={show} onHide={close} size="xl">
        <Modal.Body>
          <div className="print-container" ref={componentRef}>
            <div>
              <div className="text-center ml-4">
                <p className="p-0 m-0">ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ</p>
                <p className="p-0 m-0">
                  ສັນຕິພາບ ເອກະລາດ ປະຊາທິປະໄຕ ເອກະພາບ ວັດທະນາຖາວອນ
                </p>
              </div>
              <Row className="p-0 m-0">
                <div className="img-print-container">
                  <div className="img-print-box">
                    <img
                      src={consts.URL_IMAGE_ENTRANCE + data?.student?.image}
                      alt="Entrance print"
                      className="img-print"
                    />
                  </div>
                </div>
                <Col>
                  <Row>
                    <Col>
                      <Row className="mt-4">
                        <Col style={{ marginLeft: 5 }}>
                          <p
                            style={{ fontWeight: "normal" }}
                            className="p-0 m-0"
                          >
                            ກະຊວງສຶກສາທິການ ແລະ ກິລາ
                          </p>
                          <p
                            style={{ fontWeight: "normal" }}
                            className="p-0 m-0"
                          >
                            ຄະນະກຳມະການສອບເສັງ
                          </p>
                        </Col>
                        <Col></Col>
                      </Row>
                    </Col>
                    <div
                      className="d-flex flex-column justify-content-around"
                      style={{ width: "auto", marginTop: 35 }}
                    >
                      <div className="text-center">
                        ຫ້ອງສອບເສັງ:{" "}
                        <span className="text-primary font-number">
                          {data?.student?.classroom?.name}
                        </span>
                      </div>
                      <div className="row">
                        ເລກທີ:
                        <div
                          className="ml-2 text-center"
                          style={{ width: "fit-content" }}
                        >
                          <div className="row">
                            {splitEntranceCode?.length > 0 ? (
                              splitEntranceCode?.map((item, index) => (
                                <div
                                  className="code-box text-primary font-number"
                                  key={index}
                                >
                                  {item}
                                </div>
                              ))
                            ) : (
                              <>
                                <div className="code-box"></div>
                                <div className="code-box"></div>
                                <div className="code-box"></div>
                                <div className="code-box"></div>
                                <div className="code-box"></div>
                              </>
                            )}
                          </div>
                          <span style={{ fontSize: 10 }}>
                            (ສຳລັບພະນັກງານລົງທະບຽນ)
                          </span>
                        </div>
                      </div>
                    </div>
                  </Row>
                  <Row>
                    <div style={{ marginLeft: 5, marginTop: 15 }}>
                      <p className="p-0 m-0">
                        ຫົວໜ້າຄະນະກຳມະການສອບເສັງຄັດເລືອກເອົານັກຮຽນເຂົ້າຮຽນຕໍ່
                        ທີ່ມະຫາວິທະຍາໄລ ຈຳປາສັກ
                      </p>
                    </div>
                  </Row>
                </Col>
              </Row>
              <div className="px-5 mt-3" style={{ lineHeight: 2 }}>
                <div className="text-justify">
                  ອະນຸຍາດໃຫ້ ທ້າວ/ນາງ:
                  <span
                    className="input-data text-primary"
                    style={{ padding: "0 40px" }}
                  >
                    {convertGenderNam(data?.student?.gender)}
                    <span style={{ marginLeft: 5 }}>
                      {data?.student?.firstNameL}
                    </span>
                  </span>
                  , ນາມສະກຸນ:
                  <span
                    className="input-data text-primary"
                    style={{ padding: "0 40px" }}
                  >
                    {data?.student?.lastNameL}
                  </span>
                  , ວັນ,ເດືອນ,ປີເກີດ:
                  <span
                    className="input-data text-primary font-number"
                    style={{ padding: "0 10px", bottom: 6 }}
                  >
                    {birthDay?.[2]}
                  </span>
                  /
                  <span
                    className="input-data text-primary font-number"
                    style={{ padding: "0 10px", bottom: 6 }}
                  >
                    {birthDay?.[1]}
                  </span>
                  /
                  <span
                    className="input-data text-primary font-number"
                    style={{ padding: "0 10px", bottom: 6 }}
                  >
                    {birthDay?.[0]}
                  </span>
                  , ບ້ານເກີດ:
                  <span
                    className="input-data text-primary"
                    style={{ padding: "0 4px" }}
                  >
                    {data?.student?.birthAddress?.village}
                  </span>
                  , ເມືອງ:
                  <span
                    className="input-data text-primary"
                    style={{ padding: "0 4px" }}
                  >
                    {data?.student?.birthAddress?.district}
                  </span>
                  , ແຂວງ:
                  <span
                    className="input-data text-primary"
                    style={{ padding: "0 4px" }}
                  >
                    {data?.student?.birthAddress?.province}
                  </span>
                </div>
                <div className="d-flex">
                  <span>
                    <span style={{ fontWeight: "bold" }}>
                      ມີຈຸດປະສົງສະໜັກເຂົ້າສອບເສັງສາຍ
                    </span>{" "}
                    (ໝາຍ ✔ ໃສ່ບ໋ອກ):
                  </span>
                  <div className="d-flex">
                    <div className="code-box text-primary mt-2 ml-5">
                      {data?.group === "A" ? "✔" : ""}
                    </div>
                    <span className="ml-2">
                      ສາຍ<span className="font-number"> A</span>
                    </span>
                  </div>
                  <div className="d-flex">
                    <div className="code-box text-primary mt-2 ml-5">
                      {data?.group === "B" ? "✔" : ""}
                    </div>
                    <span className="ml-2">
                      ສາຍ<span className="font-number"> B</span>
                    </span>
                  </div>
                </div>
                <Row className="my-1">
                  <Col sm={5} md={4}>
                    <span>ທີ່ສູນສອບເສັງ (ສຳລັບພະນັກງານ):</span>
                  </Col>
                  <Col sm={7} md={8} className="p-0 m-0">
                    <Row className="p-0 m-0">
                      <Col className="p-0 m-0">
                        <div className="d-flex">
                          {/* <div className='code-box text-primary mt-2'>{data?.registrationAt === 'MORJOR' ? '✔' : ''}</div> */}
                          <div className="code-box text-primary mt-2">✔</div>
                          <span className="ml-2">ມະຫາວິທະຍາໄລ ຈຳປາສັກ</span>
                        </div>
                      </Col>
                      {/* <Col className='p-0 m-0'>
                                        <div className='d-flex'>
                                            <div className='code-box text-primary mt-2 ml-5'>{data?.registrationAt === 'ATTAPEU' ? '✔' : ''}</div>
                                            <span className='ml-2'>ແຂວງອັດຕະປື</span>
                                        </div>
                                    </Col> */}
                      {/* <Col md={3}></Col> */}
                    </Row>
                    {/* <Row className='p-0 m-0'>
                                    <Col className='p-0 m-0'>
                                        <div className='d-flex'>
                                            <div className='code-box text-primary mt-2'>{data?.registrationAt === 'SEKONG' ? '✔' : ''}</div>
                                            <span className='ml-2'>ແຂວງເຊກອງ</span>
                                        </div>
                                    </Col>
                                    <Col className='p-0 m-0'>
                                        <div className='d-flex'>
                                            <div className='code-box text-primary mt-2 ml-5'>{data?.registrationAt === 'SALAVANH' ? '✔' : ''}</div>
                                            <span className='ml-2'>ແຂວງສາລະວັນ</span>
                                        </div>
                                    </Col>
                                    <Col md={3}></Col>
                                </Row> */}
                  </Col>
                </Row>
                <Row className="p-0 m-0">
                  <Col className="p-0 m-0">
                    <span>
                      ສອບເສັງວັນທີ:
                      <span style={{ fontWeight: "bold" }}>
                        <span className="font-number"> 26</span> ສິງຫາ{" "}
                        <span className="font-number">2026</span>
                      </span>
                    </span>
                  </Col>
                  <Col className="text-right p-0 m-0 mt-4 entrance-license-container">
                    <span>
                      ທີ່:...................................,
                      ວັນທີ:......../......../
                      <span className="font-number">
                        {new Date().getFullYear()}
                      </span>
                    </span>
                    {/* <div className='text-center' style={{fontWeight: 'bold'}}>ອະທິການບໍດີ<br />(ຫົວໜ້າຄະນະກຳມະການສອບເສັງ)</div> */}
                    <div className="entrance-img-license-container">
                      {/* <img className='entrance-img-license' src='/assets/entrance-lisence.png' alt='' /> */}
                      <img
                        className="entrance-img-license"
                        src="/assets/entrance_stamp.jpeg"
                        alt=""
                        style={{ width: 290, marginTop: 20 }}
                      />
                    </div>
                  </Col>
                </Row>
                <div style={{ lineHeight: 0.5, marginBottom: 50 }}>
                  <span>ໝາຍເຫດ:</span>
                  <p className="ml-4 mt-3">
                    - ຫ້າມນຳໃຊ້ເຄື່ອງມືສື່ສານທຸກປະເພດເປັນເດັດຂາດ
                  </p>
                  <p className="ml-4">- ນຳໃຊ້ສໍດຳເທົ່ານັ້ນໃນການສອບເສັງ</p>
                  <p className="ml-4">
                    - ອາຄານສອບເສັງ...................................
                  </p>
                </div>
                <div
                  style={{ paddingTop: 60, borderBottom: "2px dotted black" }}
                />
              </div>
            </div>
          </div>
          <div className="text-center mt-5">
            <button
              className="btn btn-outline-info"
              type="button"
              onClick={close}
            >
              ຍົກເລີກ
            </button>
            <ReactToPrint
              trigger={() => <button className="btn btn-info">ສັ່ງພີມ</button>}
              content={() => componentRef.current}
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  // If being used for direct printing (without modal)
  return (
    <div ref={ref} className="print-container">
      <PrintableContent />
    </div>
  );
});

export default EntranceCard;
